export const toCurrency = (amount: any) => {
  return parseFloat(amount).toFixed(2);
}